import { Box, Typography } from '@mui/joy'

interface CallRecordPlayerProps {
    recordURL?: string
}

export const CallRecordPlayer = ({ recordURL }: CallRecordPlayerProps) => {
    return (
        <Box>
            {recordURL ? (
                <Box sx={{ px: 3, py: 1, display: 'block' }}>
                    <audio src={recordURL} style={{ height: 40, width: '100%' }} controls />
                </Box>
            ) : (
                <Typography level="body-sm" sx={{ color: 'text.gray', py: 1, m: 1, textAlign: 'center', borderRadius: 'sm' }}>
                    The recording may take a moment to appear.
                </Typography>
            )}
        </Box>
    )
}
